import { cn } from '@/lib/utils/generalUtils';
import { useId } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import ErrorMessage from './error-message';

const Input = ({
  name,
  label,
  validation,
  className,
  placeholder,
  type,
  children,
  isRequired,
  description,
  descriptionPosition = 'top',
  descriptionClassName,
}) => {
  const randomId = useId();
  const { formState, control } = useFormContext();

  const hasError = get(formState.errors, name);
  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      defaultValue=""
      render={({ field }) => (
        <div className="space-y-2">
          {!!label && (
            <label className="label !text-base" htmlFor={randomId}>
              {label} {isRequired && <span className="text-red-500"> *</span>}
            </label>
          )}

          {description && descriptionPosition === 'top' && (
            <p className={cn('text-sm text-neutral-700', descriptionClassName)}>
              {description}
            </p>
          )}

          <input
            id={randomId}
            type={type}
            min={type === 'number' ? 0 : undefined}
            className={cn('input !py-3', className)}
            placeholder={placeholder}
            {...field}
          />

          {description && descriptionPosition === 'bottom' && (
            <p className={cn('text-sm text-neutral-700', descriptionClassName)}>
              {description}
            </p>
          )}

          {children}
          {hasError && <ErrorMessage message={hasError?.message} />}
        </div>
      )}
    />
  );
};

export default Input;
